export default __webpack_public_path__ + "images/arrow_back_ios_black_24dp.svg";